import { render, staticRenderFns } from "./GroupStatusCell.vue?vue&type=template&id=32d70c9c&scoped=true"
import script from "./GroupStatusCell.vue?vue&type=script&lang=js"
export * from "./GroupStatusCell.vue?vue&type=script&lang=js"
import style0 from "./GroupStatusCell.vue?vue&type=style&index=0&id=32d70c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d70c9c",
  null
  
)

export default component.exports